import { FC } from "react";
import { DescriptionList } from "./DescriptionList";
import { DescriptionListItem } from "./DescriptionListItem";

interface InformationItemProps {
  subtitle: string;
  subtitleClarification?: string;
  descriptions: string[];
  descriptionLink?: string | undefined;
  descriptionLinkText?: string | undefined;
}

export const InformationItem: FC<InformationItemProps> = ({
  subtitle,
  subtitleClarification,
  descriptions,
  descriptionLink,
  descriptionLinkText,
}) => {
  return (
    <div className="flex flex-col justify-between md:flex-row items-start md:items-center mx-6 mb-6 md:gap-14">
      <div className="w-full mb-2 md:mb-0 text-justify">
        <h3 className="text-2xl xl:text-3xl font-bold mb-2">{subtitle}</h3>
        <p className="text-lg font-semibold italic mb-2">
          {subtitleClarification}
        </p>
        <DescriptionList>
          {descriptions.map((description, i) => (
            <DescriptionListItem key={i} index={i} description={description} />
          ))}
        </DescriptionList>
        {descriptionLink && (
          <a
            href={descriptionLink}
            target="_blank"
            rel="noreferrer"
            className="block py-2 font-medium underline hover:text-primary-dark text-md lg:inline-block break-words"
          >
            {descriptionLinkText}
          </a>
        )}
      </div>
    </div>
  );
};
